import { Button } from "antd";
import React from "react";
import "./ButtonCustom.scss";

const ButtonCustom = (props) => {
  const {
    label,
    customClass,
    disabled,
    onClick,
    basicBtn,
  } = props;
  return (
    <Button
      disabled={disabled}
      onClick={onClick}
      className={`btnCustom  ${basicBtn ? "basicBtn" : ""}  ${customClass}`}
      {...props}
    >
      {label && <span className="fontFamilyText">{label}</span>}
    </Button>
  );
};

export { ButtonCustom };
